import { render } from "./HoldInformation.vue?vue&type=template&id=8c66da00&scoped=true"
import script from "./HoldInformation.vue?vue&type=script&lang=js"
export * from "./HoldInformation.vue?vue&type=script&lang=js"

import "./HoldInformation.vue?vue&type=style&index=0&id=8c66da00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c66da00"]])

export default __exports__